export default class Address {
    constructor (
        label,
        country,
        state,
        county,
        city,
        district,
        street,
        houseNumber,
        postalCode
    ) {
        this.label = label
        this.country = country
        this.state = state
        this.county = county
        this.city = city
        this.district = district
        this.street = street
        this.houseNumber = houseNumber
        this.postalCode = postalCode
    }
}
